<template>
  <div>
    <div>
      <AnalysisActions
        :type="type"
        :read-only="readOnly"
        @addNewElement="addNewElement"
      />
      <div
        class="pb-2"
        v-for="(item) in visibleElements"
        :key="item.id"
      >
        <AnalysisElement
          :type="type"
          :item="item"
          :analysis-id="analysisId"
          :user-analysis="userAnalysis"
          :read-only="readOnly"
          @archiveElement="archiveElement"
          @archiveThreadComment="archiveThreadComment"
        />
      </div>
    </div>
  </div>
</template>
<script>
import AnalysisActions from './AnalysisActions';
import AnalysisElement from './AnalysisElement';

export default {
  name: 'AnalysisElementSection',
  components: { AnalysisElement, AnalysisActions },
  props: {
    type: {
      type: String,
      required: true,
    },
    elements: {
      type: Array,
      required: true,
    },
    userAnalysis: {
      type: Object,
      required: true,
    },
    analysisId: {
      type: String,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    visibleElements() {
      return this.elements.filter(element => !element.archived || element.archived === false);
    },
  },
  methods: {
    addNewElement(data) {
      this.$emit('addNewElement', data);
    },
    archiveElement(elementAndType) {
      this.$emit('archiveElement', elementAndType);
    },
    archiveThreadComment(commentId) {
      this.$emit('archiveThreadComment', commentId);
    },
  },
};
</script>
<style scoped>
.divider {
  margin-left: 61px;
  margin-right: 24px;
  padding-bottom: 4px;
}
</style>
